export type MaybeFunction<Args extends any[], Result> = Result | ((...args: Args) => Result);

export function functor<Args extends any[], Result>(value: MaybeFunction<Args, Result>): (...args: Args) => Result {
    return typeof value == 'function'
        ? value as (...args: Args) => Result
        : () => value;
}

/** Does nothing. Useful when you don't want to keep creating new empty arrow functions. */
export function noop() { }